import get from 'lodash/get';
import initialBookingStateSelector from '../../selectors/InitialBookingStateSelector';
import { DOCTOR_CARD_ROOT_KEY } from '../../constants';

export const mapStateToProps = state => {
    const initialBookingState = initialBookingStateSelector(state);

    const professional = state[DOCTOR_CARD_ROOT_KEY].professional;

    return {
        officePhoneNumber: initialBookingState.officePhoneNumber,
        directoryId: get(initialBookingState, 'directoryId', -1) || -1,
        hasVirtualLocations: get(professional, 'hasVirtualLocations', false),
        profileUrl: get(professional, 'profileUrl'),
        professionalName: get(professional, 'nameInSentence'),
        image: get(professional, 'image'),
        showPhotoWithCircleCss: get(professional, 'showPhotoWithCircleCss'),
        firstVirtualLocation: get(professional, 'firstVirtualLocation'),
    };
};
